/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import classNames from 'classnames';
import { PROJECT_NAME } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { FieldFeedback, RenderInput } from '#components/support/forms/utility/index.js';
import Field from '#components/pages/Models/Model/sections/support/forms/Field/index.js';

type Props = {|
  form: string,
  projects: string[],
|};

const ProjectSelector = (props: Props): Element<typeof FormGroup> => {
  const { projects, form } = props;
  const hasExistingProjects = projects.length !== 0;
  const showNewProjectToggle = hasExistingProjects;
  const [isNew, setIsNew] = React.useState(!hasExistingProjects);
  const newOrExistingText = isNew ? 'Select Existing' : 'Create New';
  const options = projects.map(p => (
    <option key={p} value={p}>
      {p}
    </option>
  ));
  const optionsComponents = !isNew ? (
    <>
      <option />
      {options}
    </>
  ) : null;

  return (
    <FormGroup>
      <Label htmlFor={PROJECT_NAME}>Project</Label>
      <Row>
        <Col lg="9">
          <Field
            form={form}
            id={PROJECT_NAME}
            name={PROJECT_NAME}
            type={isNew ? 'text' : 'select'}
            component={RenderInput}
            inputClassName={classNames('custom-select', 'project-selector')}
          >
            {optionsComponents}
          </Field>
          <FieldFeedback name={PROJECT_NAME} form={form} />
        </Col>
        <Col className="pl-0 pr-0">
          {showNewProjectToggle && (
            <Button
              id={isNew ? 'selectExistingPrjBtn' : 'createNewProjBtn'}
              color="link"
              onClick={() => setIsNew(!isNew)}
              className="pl-0 pr-0"
            >
              {newOrExistingText}
            </Button>
          )}
        </Col>
      </Row>
    </FormGroup>
  );
};

export default ProjectSelector;
